import React from "react";
import { HeartHandshake, ArrowRight } from "lucide-react";
import { useApp } from "../state/AppContext";
import { logSiteClick } from "../lib/siteClick";

const ENROLL_BASE = "https://www.schoolforcommunitylearning.org/enrollment#enrollment-application";

function buildApplyUrl(sourcePath, utmContent) {
  const medium = sourcePath === "spinner" ? "spinner" : "kindness";
  const params = new URLSearchParams();
  params.set("utm_source", "app");
  params.set("utm_medium", medium);
  params.set("utm_campaign", "kindness2026");
  if (utmContent) params.set("utm_content", utmContent);
  return `${ENROLL_BASE}?${params.toString()}`;
}

export default function ApplyCTA({ className = "" }) {
  const ctx = useApp();
  const { t, sourcePath, utmContent } = ctx;
  const href = buildApplyUrl(sourcePath, utmContent);

  return (
    <div
      className={`bg-white rounded-2xl overflow-hidden shadow-warm-sm border border-scl-teal/15 ${className}`}
      data-testid="apply-cta"
    >
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-br from-scl-teal/8 via-transparent to-scl-mustard/15 pointer-events-none" />
        <div className="relative p-5 flex items-start gap-4">
          <div className="w-11 h-11 rounded-xl bg-scl-teal/12 flex items-center justify-center flex-shrink-0">
            <HeartHandshake className="w-5 h-5 text-scl-teal" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[10px] uppercase tracking-[0.18em] text-scl-teal font-semibold mb-1">{t("apply_kicker")}</div>
            <h3 className="font-serif text-lg sm:text-xl text-scl-charcoal font-bold leading-snug">{t("apply_headline")}</h3>
            <p className="text-[14px] text-scl-charcoal/75 mt-1.5 leading-relaxed">{t("apply_body")}</p>
            <a
              href={href}
              target="_blank"
              rel="noreferrer"
              onClick={() => logSiteClick(ctx, "apply_cta", href)}
              data-testid="apply-btn"
              data-source-path={sourcePath || ""}
              className="mt-4 inline-flex items-center gap-2 min-h-[44px] px-5 rounded-full bg-scl-teal text-white font-semibold text-sm hover:brightness-110 active:scale-[0.98] transition-all shadow-warm-sm"
            >
              {t("apply_button")} <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
